module.exports = __webpack_public_path__ + "static/media/Testimonio_VICKY.88135a36.png";